import { render, staticRenderFns } from "./NotAvailableInternationalPage.vue?vue&type=template&id=f1daf674"
import script from "./NotAvailableInternationalPage.vue?vue&type=script&lang=js"
export * from "./NotAvailableInternationalPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports